const hasStatusCode = error => {
  return error !== null && ('statusCode' in error || 'status' in error);
};

/* Aborted CHIRP requests surface with `status: 0` ("failed with status 0.
 * Request aborted") when the page is torn down before the query resolves
 * (navigation, refresh, browser close). They are not real failures. We
 * deliberately do NOT treat missing/null statusCode as aborted — real network
 * errors with non-CHIRP bodies can land here without a statusCode and should
 * still surface as errors. Mirrors the in-app
 * pricing-pages-ui/static/js/v2/utils/apiLogging#isAbortedQueryError. */
export const isAbortedQueryError = error => {
  var _networkError$statusC;
  const networkError = error === null || error === void 0 ? void 0 : error.networkError;
  if (!networkError) {
    return false;
  }
  if (networkError.name === 'AbortError') {
    return true;
  }
  if (!hasStatusCode(networkError)) {
    return false;
  }
  const statusCode = (_networkError$statusC = networkError.statusCode) !== null && _networkError$statusC !== void 0 ? _networkError$statusC : networkError.status;
  return statusCode === 0;
};